export const DEFAULT_TIME_ENTRY_VALUE = '0:00';
export const DEFAULT_TIME_ENTRY_SECONDS = 0;
export const TIME_ENTRY_ANIMATION_DURATION = 800;
export const HIGHLIGHT_INPUT_ERROR_WAIT = 150;
